import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Image, Container, Col, Jumbotron } from 'react-bootstrap';

function BookingWelcomeCard(props) {

    const { licenseName } = useParams();
    const [license] = useState(licenseName);

    const logotypeUrl = `/api/${license}/logotype`;
    const coverUrl = `/api/${license}/cover`;

    const headerStyle = {
        backgroundImage: `url("${coverUrl}")`,
        //backgroundSize: '851px 315px',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        //backgroundColor: '#ffffff',
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        backgroundBlendMode: 'lighten'
    }

    function getPresentation() {
        if (props !== null) {
            let presentation = props
                .customerData
                .settings
                .OnlineBookingPresentation;
            /*if (presentation !== null) {
                return presentation.split('\r\n').map((row) => (
                    <p key={row}>{row}</p>
                ));
            }*/
            return presentation;
        }
        return <React.Fragment></React.Fragment>;
    }

    function getCompanyName() {
        if ('OnlineCompanyName' in props.customerData.settings)
            if (props.customerData.settings.OnlineCompanyName)
                return props.customerData.settings.OnlineCompanyName
        return props.customerData.settings.CompanyName;
    }

    return (
        <Jumbotron style={headerStyle}>
            <Container>
                <Row className="justify-content-md-center">
                    <Col xs={5} md={3}>
                        <Image className="logotype-image" src={logotypeUrl}></Image>
                    </Col>
                    <Col xs={7} md={9} style={{ textAlign: 'right' }}>
                        <h4 className="small-text">Boka tid hos</h4>
                        <h1 className="medium-text bold-text">{getCompanyName()}</h1>
                        <p style={{ whiteSpace: 'normal' }} className="small-text">{getPresentation()}</p>
                    </Col>
                </Row>
            </Container>
        </Jumbotron>
    )

}

export default BookingWelcomeCard;